import { connect } from "react-redux"

import { setShippingCountry } from "../../../redux/order/actions"
import ChangeCountryDialogView from "./change-country-dialog-view"

export default connect(null, {
  setShippingCountry,
})(ChangeCountryDialogView)
